var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Avatar } from '@robinpowered/ui-kit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@awesome.me/kit-cf858715fd/icons/classic/regular';
// Used for appropriate avatar fallbacks with a robin user since
// ant does not handle it gracefully
export var RobinAvatar = function (_a) {
    var src = _a.src, name = _a.name, _b = _a.size, size = _b === void 0 ? 'small' : _b, icon = _a.icon, props = __rest(_a, ["src", "name", "size", "icon"]);
    return (_jsx(_Fragment, { children: src ? (_jsx(Avatar, __assign({ size: size, src: src, name: name || '', alt: name || '', "data-testid": "avatar-with-image", icon: icon !== null && icon !== void 0 ? icon : _jsx(FontAwesomeIcon, { icon: faUser }) }, props, { children: _jsx(FontAwesomeIcon, { icon: faUser }) }))) : name ? (_jsx(Avatar, __assign({ size: size, name: name, alt: name || '', "data-testid": "avatar-with-name" }, props))) : (_jsx(Avatar, __assign({ size: size, icon: icon !== null && icon !== void 0 ? icon : _jsx(FontAwesomeIcon, { icon: faUser }), alt: name || '', "data-testid": "avatar-with-icon" }, props))) }));
};
